import { Box, Divider, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useColors from "../../../../../api/hooks/useColors";
import ContainedButton from "../../../../../components/buttons/ContainedButton";
import InputLabel from "../../../../../components/chips/InputLabel";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import {
  icons,
  severities,
} from "../../../../stack/environment/icons/iconExport";
import WorkflowCardContent from "./WorkflowCardContent";

const WorkflowCardTemplate = ({ data }) => {
  const colors = useColors();
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: 416,
        minWidth: 416,
        height: 310,
        minHeight: 310,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        borderRadius: "10px",
        boxShadow: "0px 1px 4px 0px " + colors.grey_48percent,
        backgroundColor: colors.common_white,
        padding: "24px",
        gap: "16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          justifyContent: "center",
          width: "100%",
          height: "100%",
        }}
      >
        {data.available ? (
          data.inUse ? (
            <InputLabel
              label={"In Use"}
              size="medium"
              icon={severities.SeveritySuccessIcon}
              iconSize="16px"
            />
          ) : (
            <InputLabel label={"Available"} size="medium" />
          )
        ) : data.missingTools ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <InputLabel
              label={"Missing integration: " + data.missingTools.join(", ")}
              size="medium"
              icon={severities.SeverityErrorIcon}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 1,
                color: colors.primary_main,
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/inventory/integrations", {
                  state: { toolName: data.missingTools.join(", ") },
                });
              }}
            >
              <Typography variant="caption">Fix </Typography>
              <SvgToIcon IconLogo={icons.arrow} style={{ width: "16px" }} />
            </Box>
          </Box>
        ) : (
          <InputLabel label={"Not Available"} size="medium" />
        )}
        <WorkflowCardContent data={data} isTemplate={true} />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
        }}
      >
        <Divider orientation="horizontal" flexItem />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            justifyContent: "flex-end",
          }}
        >
          <ContainedButton
            onClick={() => {}}
            color="primary"
            size="small"
            loading={false}
            disabled={false}
          >
            Preview & Configure
          </ContainedButton>
        </Box>
      </Box>
    </Box>
  );
};

export default WorkflowCardTemplate;
